import React, { useState } from 'react';
import { LinkComponent } from '../../LinkComponent';
import QRCode from 'react-qr-code';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';

interface Props {
	closeModal: () => void;
	onConfirm: () => void;
	code: string | null;
	accountName: string | null;
	showCloseButton?: boolean;
}

export const SecurityAppForm = (props: Props): React.ReactElement => {
	const { closeModal, onConfirm, code, accountName, showCloseButton = 'true' } = props;
	const codeURL = `otpauth://totp/${accountName}?secret=${code}`;
	const [useQRCode, setUseQRCode] = useState<boolean>(true);

	const togglePages = (): void => setUseQRCode(prev => !prev);

	return (
		<div className="px-8">
			<div className="px-5 text-center">
				Download the free{' '}
				<span className="fw-bolder">Google Authenticator</span>{' '}
				(
				<LinkComponent text="Android" link='https://play.google.com/store/search?q=google+authenticator+code&c=apps&hl=en&gl=US'/>,{' '}
				<LinkComponent text="iOS" link='https://apps.apple.com/us/app/google-authenticator/id388497605'/>)
				app, add a new account, then  scan this QR code to set up your account.
			</div>
			<div className="d-flex justify-content-center mt-5">
				{
					useQRCode
						? <QRCode size={150} value={codeURL ?? ''} />
						: <input
								className="form-control form-control-lg form-control-solid mx-5 my-16"
								value={code}
								disabled
							/>
				}

			</div>
			<div className="text-center mt-5">
				<ButtonComponent
					buttonName='Enter code manually'
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={togglePages}
				/>
			</div>
			<div className="text-center mt-7">
				{showCloseButton && (
					<ButtonComponent
						buttonName="Cancel"
						buttonType={BUTTON_TYPE.CANCELLED}
						additionalClass="btn-sm me-10"
						onButtonClick={closeModal}
					/>
				)}
				<ButtonComponent
					buttonName="Confirm"
					additionalClass="btn-sm"
					onButtonClick={onConfirm}
				/>
			</div>
		</div>
	);
};
